// check if range controller input numbers  has value
export const hasVal = (val) => val || val === 0;
